import React from 'react';
import { Box } from '@heycater/design-system';
import { Divider } from '@material-ui/core';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';

import MainLayout from 'shared/layouts/MainLayout';
import { fetchRatings } from 'shared/services/trustedShops/fetchRatings';
import CTAWithBenefits from 'static_pages/components/CTAWithBenefits';
import HowItWorksCTA from 'static_pages/marketing_pages/components/HowItWorksCTA';
import PartnersCTA from 'static_pages/marketing_pages/components/PartnersCTA';
import { AreaWithSidebarCTA } from 'static_pages/marketing_pages/components/SidebarCTA';
import CountryImage from 'static_pages/marketing_pages/country_landing_page/components/CountryImage';
import CountryListing from 'static_pages/marketing_pages/country_landing_page/components/CountryListing';
import Hero from 'static_pages/marketing_pages/country_landing_page/components/Hero';
import SearchBar from 'static_pages/marketing_pages/country_landing_page/components/SearchBar';
import TextSection from 'static_pages/marketing_pages/country_landing_page/components/TextSection';
import Container from 'system/components/Container';

function CountryLandingPage({ page, ratings }) {
  const { t } = useTranslation('static_pages');
  return (
    <MainLayout ratings={ratings}>
      <Head>
        <title>{page.metaTitle}</title>
        <meta name="description" content={page.metaDescription} />
        <meta property="og:title" content={page.metaTitle} />
        <meta property="og:description" content={page.metaDescription} />
      </Head>

      <Hero
        title={page.heroTitle}
        subtitle={page.heroSubtitle}
        cityFromSlug={page.cityFromSlug}
      />

      <AreaWithSidebarCTA
        title={t('marketingPages.sidebar.title')}
        subtitle={t('marketingPages.sidebar.body')}
        ctaText={t('marketingPages.sidebar.cta')}
      >
        <Container size="xs">
          <Box pt={{ xs: 2, md: 6 }} pb={2}>
            <TextSection body={page.section1Body} />
          </Box>

          <Box pb={3}>{page.image && <CountryImage {...page.image} />}</Box>

          <Box display="flex" justifyContent={{ xs: 'center', sm: 'flex-end' }}>
            <SearchBar cities={page.cityList} />
          </Box>

          <Box pb={4}>
            <CountryListing cities={page.cityList} slug={page.slug} />
          </Box>

          <Divider />

          <Box pb={2} pt={2}>
            <TextSection body={page.section2Body} />
          </Box>
        </Container>
      </AreaWithSidebarCTA>
      <Container size="sm">
        <Box pb={2}>
          <HowItWorksCTA />
        </Box>
        <PartnersCTA />
      </Container>
      <CTAWithBenefits containerSize="sm" />
    </MainLayout>
  );
}

export async function getStaticProps() {
  const ratings = await fetchRatings();
  return {
    props: {
      robots: 'none',
      ratings,
    },
  };
}

export default CountryLandingPage;
